import type { Locale } from "./locale-context";

/** The browser tab title everywhere inside the signed-in portal. */
export const PORTAL_TITLE = "OctoMail";

/** True for /app and every /app/* route (not /apps or /application). */
export function isPortalPath(pathname: string): boolean {
  return pathname === "/app" || pathname.startsWith("/app/");
}

/** Tab title for a route: the plain product name in the portal, the
 *  localized marketing title everywhere else. */
export function titleFor(pathname: string, metaTitle: string): string {
  return isPortalPath(pathname) ? PORTAL_TITLE : metaTitle;
}

/**
 * Decides which LocaleProvider owns document.title and <html lang>. A pinned
 * provider (the /, /uz, /ru landing routes) always wins over the app-wide
 * detected one, whatever order React runs their effects in.
 */
export function createDocumentLocale(apply: (l: Locale) => void) {
  let base: Locale | null = null;
  const pins: Locale[] = [];
  return {
    setBase(l: Locale) {
      base = l;
      if (pins.length === 0) apply(l);
    },
    /** Re-apply whichever locale currently owns the document (after a route
     *  change, so route-dependent output such as the title follows). */
    refresh() {
      const top = pins[pins.length - 1];
      if (top) apply(top);
      else if (base) apply(base);
    },
    pin(l: Locale): () => void {
      pins.push(l);
      apply(l);
      return () => {
        const i = pins.lastIndexOf(l);
        if (i >= 0) pins.splice(i, 1);
        const top = pins[pins.length - 1];
        if (top) apply(top);
        else if (base) apply(base);
      };
    },
  };
}
